module.exports = __webpack_public_path__ + "media/application/images/icons/values-integrity-pebble-dark-green-rgb-0d26f02d6043e9cf0973ffdfd817321e.svg";